module.exports = __webpack_public_path__ + "img/p2-82.58505e94.png";